import React from "react";
import { withTranslation } from "react-i18next";
import { Map, TileLayer, LayersControl } from "react-leaflet";
import ClusterGroup from "./ClusterGroup";
import HeatMap from "./HeatMap";
import { shallowEqual } from "./Utils";
import Spinner from "react-bootstrap/Spinner";
import "./Map.css";

const position_center = [40, -3.2];
const mapStyle = {
    width: "100%",
    height: "500px",
    border: "2px solid #c5c5c5"
};

class MapComponent extends React.Component {

    map

    state = {
        forceCluster: false,
        zoom: 5
    };

    renderLoading = () => {
        if (this.props.loading) {
            return <MapSpinner />;
        }
        return null;
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (!shallowEqual(this.state, nextState)) {
            return true;
        } else {
            if (this.props.loading !== nextProps.loading) {
                return true;
            } else if (this.props.tileType !== nextProps.tileType) {
                return true;
            } else if (this.props.mapType !== nextProps.mapType) {
                return true;
            } else if (this.props.markers.length !== nextProps.markers.length) {
                return true;
            }
            return false;
        }
    }

    checkForceCluster = e => {
        var actual_zoom = e.target._zoom;
        if (this.props.tileType === "HEAT" && parseInt(actual_zoom) > 9) {
            this.setState({ forceCluster: true });
        } else if (this.props.tileType === "HEAT" && this.state.forceCluster) {
            this.setState({ forceCluster: false });
        }
        return;
    };

    calculateHeatCords = () => {
        return this.props.markers.map(m => m.heat);
    };

    getSibicRecords = () => {
        return this.props.markers.filter(m => m.type === "SIBIC");
    };

    getEasinRecords = () => {
        return this.props.markers.filter(m => m.type !== "SIBIC");
    };


    render() {

        return (
            <div className="leaflet-container">
                {this.renderLoading()}
                <Map
                    ref={(ref) => { this.map = ref }}
                    className={this.props.hideControl ? 'map-hide-controls': undefined}
                    preferCanvas={false}
                    center={position_center}
                    zoomAnimation={true}
                    minZoom={3}
                    zoom={this.state.zoom}
                    maxZoom={15}
                    zoomControl={true}
                    doubleClickZoom={true}
                    scrollWheelZoom={true}
                    dragging={true}
                    animate={true}
                    easeLinearity={0.35}
                    style={mapStyle}
                    onzoomend={this.checkForceCluster}
                >
                    <LayersControl position="topright">
                        <LayersControl.BaseLayer
                            name="Mapa"
                            checked={this.props.mapType === "MAP"}
                        >
                            <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.BaseLayer
                            name="Satelite"
                            checked={this.props.mapType !== "MAP"}
                        >
                            <TileLayer
                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
                            />
                        </LayersControl.BaseLayer>
                        <LayersControl.Overlay name="Cluster" checked={this.props.tileType === "CLUSTER" || this.state.forceCluster}>
                             <ClusterGroup
                                 map={this.map}
                                 sibicRecords={this.getSibicRecords()}
                                 easinRecords={this.getEasinRecords()}
                             />
                        </LayersControl.Overlay>
                        <LayersControl.Overlay name="Calor" checked={this.props.tileType === "HEAT" && !this.state.forceCluster}>
                              <HeatMap points={this.calculateHeatCords()} />
                        </LayersControl.Overlay>
                    </LayersControl>
                </Map>
            </div>
        );
    }
}

export default withTranslation()(MapComponent);

const MapSpinner = props => (
    <div
        className="my_spinner"
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}
    >
        <div>
            <Spinner className="spin m-3" animation="grow" variant="success" />
            <Spinner className="spin m-3" animation="grow" variant="info" />
            <Spinner className="spin m-3" animation="grow" variant="success" />
        </div>
    </div>
);
